import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import { Box, Button, TextField, Typography } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import useAlias from '@src/hooks/useAlias';
import { useSettings } from '../../hooks/useSettings';
import { inputStyles } from '../styles';

interface SettingFormProps {
  isEditMode?: boolean;
  editingSettingLabel?: string;
}

const SettingForm = ({
  isEditMode,
  editingSettingLabel,
}: SettingFormProps = {}) => {
  const alias = useAlias();
  const {
    newSettingData,
    newSettingErrors,
    handleNewSettingChange,
    setShowAddSetting,
    addNewSetting,
    isSettingEditMode,
    editingSetting,
  } = useSettings();

  // Use props if provided, otherwise use values from context
  const effectiveIsEditMode =
    isEditMode !== undefined ? isEditMode : isSettingEditMode;
  const effectiveEditingLabel =
    editingSettingLabel || (editingSetting ? editingSetting.uiLabel : '');
  return (
    <Grid2
      container
      spacing={2}
      size={12}
      sx={{
        mt: effectiveIsEditMode ? 1 : 3,
        mb: effectiveIsEditMode ? 2 : 0,
        p: 2,
        backgroundColor: (theme) =>
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, 0.03)'
            : 'rgba(0, 0, 0, 0.02)',
        border: (theme) => `1px solid ${theme.palette.divider}`,
        borderRadius: '4px',
      }}
    >
      <Grid2 size={12}>
        <Typography variant='h6' gutterBottom>
          {effectiveIsEditMode
            ? alias('Edit Setting "{effectiveEditingLabel}"', {
                effectiveEditingLabel,
              })
            : alias('Add New Setting')}
        </Typography>
      </Grid2>

      <Grid2 size={6}>
        <TextField
          fullWidth
          label={alias('Setting Label')}
          name='uiLabel'
          value={newSettingData.uiLabel}
          onChange={handleNewSettingChange}
          variant='outlined'
          size='small'
          error={!!newSettingErrors['uiLabel']}
          helperText={newSettingErrors['uiLabel']}
          sx={inputStyles}
        />
      </Grid2>

      <Grid2 size={6}>
        <TextField
          fullWidth
          label={alias('Controller Field')}
          name='controllerField'
          value={newSettingData.controllerField}
          onChange={handleNewSettingChange}
          variant='outlined'
          size='small'
          error={!!newSettingErrors['controllerField']}
          helperText={newSettingErrors['controllerField']}
          sx={inputStyles}
        />
      </Grid2>

      <Grid2 size={12} sx={{ mt: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button
            variant='outlined'
            color='primary'
            onClick={() => setShowAddSetting(false)}
          >
            <FormattedAlias id='Cancel' />
          </Button>
          <Button variant='contained' color='primary' onClick={addNewSetting}>
            {effectiveIsEditMode ? (
              <FormattedAlias id='Save' />
            ) : (
              <FormattedAlias id='Add Setting' />
            )}
          </Button>
        </Box>
      </Grid2>
    </Grid2>
  );
};

export default SettingForm;
